/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

// @ts-ignore
import Highcharts from './Highcharts';

// This file was created to comply with TypeScript compiler rules regarding importing
// javascript files which do not have or do not provide type information (declaration).
// The file above, Highcharts, is a javascript file, it does not provide types declaration,
// but we need to use that file in a many places, so, to avoid suppressing TS compiler errors in every place
// it's easier to create file like this, suppress the warning about loading Highcharts.js file.

export default Highcharts;
